import { Component, OnDestroy, OnInit } from '@angular/core';
import { RrqFormFactory } from './rrq-form.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CalculationStore } from '../../../../../stores/calculation.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { RrqOptions } from '../../../../../../../../../../../common/src/options/calculations/rrq/rrq.options';
import { CalculationBaseForm } from '../../../base-form/form/base-form/calculation-base.form';
import { CalculationsUtils } from '../../../../../utils/calculations.utils';
import { AlertMessageStore } from '../../../../../../core/stores/alert-message.store';
import { ImportManager } from '../../../../../managers/import.manager';
import {
  CalculationKeynameEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { FormChangeManager } from '../../../../../managers/form-change.manager';
import { CalculationLifecycleManager } from '../../../../../managers/calculation-lifecycle.manager';
import { EventManager } from '../../../../../../core/managers/event.manager';


@Component({
  selector: 'app-rrq-form',
  templateUrl: './rrq-form.component.html',
  styleUrls: ['./rrq-form.component.scss'],
  standalone: false,
})
export class RrqFormComponent extends CalculationBaseForm<RrqOptions> implements OnInit, OnDestroy {

  isExecuteButtonEnabled: boolean = false;

  constructor(public readonly formFactory: RrqFormFactory,
              calculationStore: CalculationStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              importManager: ImportManager,
              calculationLifecycleManager: CalculationLifecycleManager,
              formChangeManager: FormChangeManager,
              eventManager: EventManager,
  ) {
    super(formFactory, calculationStore, translateService, activatedRoute, modalService, router, optionsMapper, calculationsUtils, alertMessageStore, CalculationKeynameEnum.RRQ, importManager, calculationLifecycleManager, formChangeManager, eventManager);
    this.optionsType = RrqOptions;
  }
}
